/* SALTs wedding landing — shared behaviour for the swl-* sections.
   Loaded once per page (guarded), re-initialises sections reloaded in the theme editor. */
(function () {
  if (window.SWL) return;
  var SWL = (window.SWL = {});
  var reduce = function () { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- flavour data (read from the flavours section buttons) ---------- */
  function flavourMap() {
    var map = {};
    document.querySelectorAll('[data-swl-flavour]').forEach(function (b) { map[b.dataset.id] = b; });
    return map;
  }

  /* ---------- flavour picker ---------- */
  function initPicker(root) {
    root.querySelectorAll('[data-swl-picker]').forEach(function (picker) {
      if (picker.dataset.swlReady) return;
      picker.dataset.swlReady = '1';
      var feat = picker.querySelector('.feat'), img = picker.querySelector('[data-feat-img]'),
          nm = picker.querySelector('[data-feat-name]'), best = picker.querySelector('[data-feat-best]'),
          link = picker.querySelector('[data-feat-link]');
      var btns = picker.querySelectorAll('[data-swl-flavour]');
      function select(id) {
        var b = picker.querySelector('[data-swl-flavour][data-id="' + id + '"]');
        if (!b) return;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        feat.style.setProperty('--tint', b.dataset.tint);
        if (img && img.getAttribute('src') !== b.dataset.img) {
          img.classList.add('swap');
          setTimeout(function () {
            img.removeAttribute('srcset');
            if (b.dataset.imgF) img.setAttribute('data-f', b.dataset.imgF); else img.removeAttribute('data-f');
            img.src = b.dataset.img; img.alt = b.dataset.alt || '';
            img.classList.remove('swap');
          }, 160);
        }
        nm.textContent = b.dataset.name;
        best.textContent = b.dataset.best;
        if (link) {
          link.textContent = b.dataset.cta;
          link.href = b.dataset.url;
        }
      }
      picker.swlSelect = select;
      picker.addEventListener('click', function (e) {
        var b = e.target.closest('[data-swl-flavour]');
        if (b) select(b.dataset.id);
      });
      btns.forEach(function (b) { var p = new Image(); p.src = b.dataset.img; });
    });
  }

  /* ---------- "Pour" chips on function cards ---------- */
  function initPour() {
    var map = flavourMap();
    document.querySelectorAll('.swl .pchip[data-flavour]').forEach(function (a) {
      var b = map[a.dataset.flavour];
      if (!a.querySelector('img') && b && b.dataset.thumb) {
        var im = document.createElement('img');
        if (b.dataset.thumbF) { im.setAttribute('data-f', b.dataset.thumbF); im.onerror = function () { window.swlImg && swlImg(im); }; }
        im.src = b.dataset.thumb; im.alt = ''; im.width = 34; im.height = 34; im.loading = 'lazy';
        a.insertBefore(im, a.firstChild);
      }
      if (a.dataset.swlReady) return;
      a.dataset.swlReady = '1';
      a.addEventListener('click', function (e) {
        var m = flavourMap()[a.dataset.flavour];
        var picker = m && m.closest('[data-swl-picker]');
        if (!picker || !picker.swlSelect) return; // no flavours section: let the anchor link work
        e.preventDefault();
        picker.swlSelect(a.dataset.flavour);
        var sec = picker.closest('section') || picker;
        sec.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- buttons that pre-select a role in the quote form ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-swl-role]');
    if (!t) return;
    var want = t.dataset.swlRole;
    document.querySelectorAll('.swl-quote input[name="contact[Role]"]').forEach(function (r) { if (r.value === want) r.checked = true; });
  });

  /* ---------- quote form ---------- */
  function initForm(root) {
    root.querySelectorAll('[data-swl-form]').forEach(function (wrap) {
      if (wrap.dataset.swlReady) return;
      wrap.dataset.swlReady = '1';
      var form = wrap.querySelector('form'), done = wrap.querySelector('[data-swl-done]'),
          fields = wrap.querySelector('[data-swl-fields]'), alertBox = wrap.querySelector('[data-swl-alert]');
      if (!form) return;
      var key = 'swl-quote-' + (wrap.dataset.sectionId || '');
      var msg = JSON.parse(wrap.querySelector('[data-swl-messages]').textContent || '{}');
      var q = function (n) { return form.querySelector('[name="contact[' + n + ']"]'); };

      // Success state: rebuild the summary saved before submit.
      if (done && !done.hidden) {
        var saved = ss.get(key);
        var dl = done.querySelector('dl');
        if (saved && dl) {
          try {
            var data = JSON.parse(saved);
            data.rows.forEach(function (r) {
              var dt = document.createElement('dt'), dd = document.createElement('dd');
              dt.textContent = r[0]; dd.textContent = r[1]; dl.appendChild(dt); dl.appendChild(dd);
            });
            var h = done.querySelector('[data-swl-done-h]');
            if (h && data.first) h.textContent = h.dataset.tpl.replace('[name]', data.first);
          } catch (e) {}
        }
        ss.del(key);
        if (dl && !dl.children.length) dl.hidden = true;
        var again = done.querySelector('[data-swl-again]');
        if (again) again.addEventListener('click', function () {
          done.hidden = true; fields.hidden = false;
          var n = q('name'); if (n) n.focus();
        });
        if (!/[?&]contact_posted=true/.test(location.search) || location.hash) done.scrollIntoView({ block: 'center' });
      }

      var dateEl = q('Wedding date');
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var iso = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      if (dateEl) dateEl.min = iso;

      function errEl(el) { return document.getElementById(el.getAttribute('aria-describedby')); }
      function setErr(el, m) {
        var e = errEl(el); if (e) e.textContent = m || '';
        if (el.tagName === 'FIELDSET') { if (m) el.setAttribute('data-invalid', ''); else el.removeAttribute('data-invalid'); }
        else el.setAttribute('aria-invalid', m ? 'true' : 'false');
        return !m;
      }
      var checks = {
        'name': function (v) { return v.trim().length < 2 ? msg.name : ''; },
        'phone': function (v) {
          var d = v.replace(/[\s\-()]/g, '').replace(/^\+?91/, '').replace(/^0/, '');
          return /^[6-9]\d{9}$/.test(d) ? '' : msg.phone;
        },
        'email': function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) ? '' : msg.email; },
        'Wedding date': function (v) { if (!v) return msg.date; return v < iso ? msg.date_past : ''; },
        'City': function (v) { return v.trim().length < 2 ? msg.city : ''; },
        'Guests': function (v) { var n = Number(v); return (!v || !Number.isInteger(n) || n < 1) ? msg.guests : ''; },
        'Functions': function (v) { return v ? '' : msg.functions; }
      };
      Object.keys(checks).forEach(function (k) {
        var el = q(k); if (!el) return;
        el.addEventListener('blur', function () { if (el.value) setErr(el, checks[k](el.value)); });
        el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') setErr(el, checks[k](el.value)); });
      });
      var fsRole = form.querySelector('[data-fs="role"]'), fsInt = form.querySelector('[data-fs="interest"]');
      var hiddenInt = q('Interests'), intSummary = form.querySelector('[data-swl-int-summary]');
      if (fsRole) fsRole.addEventListener('change', function () { setErr(fsRole, ''); });
      if (fsInt) fsInt.addEventListener('change', function (e) {
        var boxes = fsInt.querySelectorAll('input[type=checkbox]');
        var exclusive = e.target.hasAttribute('data-exclusive');
        if (exclusive && e.target.checked) boxes.forEach(function (i) { if (i !== e.target) i.checked = false; });
        else if (e.target.checked) boxes.forEach(function (i) { if (i.hasAttribute('data-exclusive')) i.checked = false; });
        setErr(fsInt, '');
      });

      form.addEventListener('submit', function (e) {
        var firstBad = null, bad = 0;
        Object.keys(checks).forEach(function (k) {
          var el = q(k); if (!el) return;
          if (!setErr(el, checks[k](el.value))) { bad++; firstBad = firstBad || el; }
        });
        var role = fsRole && form.querySelector('input[name="contact[Role]"]:checked');
        if (fsRole && !setErr(fsRole, role ? '' : msg.role)) { bad++; firstBad = firstBad || fsRole.querySelector('input'); }
        var ints = fsInt ? Array.prototype.map.call(fsInt.querySelectorAll('input[type=checkbox]:checked'), function (i) { return i.value; }) : [];
        if (fsInt && !setErr(fsInt, ints.length ? '' : msg.interest)) { bad++; firstBad = firstBad || fsInt.querySelector('input'); }

        if (bad) {
          e.preventDefault();
          alertBox.hidden = false;
          alertBox.textContent = bad === 1 ? msg.one_fix : msg.many_fix.replace('[count]', bad);
          firstBad.focus();
          return;
        }
        alertBox.hidden = true;
        if (hiddenInt) hiddenInt.value = ints.join(', ');
        if (intSummary) intSummary.value = ints.join(', ');

        // Save a summary so the success screen can echo it back after Shopify's reload.
        var rows = [];
        form.querySelectorAll('[data-summary]').forEach(function (el) {
          var v = el.value && el.value.trim();
          if (el.type === 'radio') { if (!el.checked) return; }
          if (!v) return;
          if (el.type === 'date') {
            var d = new Date(v + 'T00:00:00');
            v = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
          }
          if (el.type === 'number') v = Number(v).toLocaleString('en-IN');
          rows.push([el.dataset.summary, v]);
        });
        var nm = q('name');
        ss.set(key, JSON.stringify({ rows: rows, first: nm ? nm.value.trim().split(' ')[0] : '' }));
      });
    });
  }

  /* ---------- mobile CTA dock ---------- */
  function initDock(root) {
    root.querySelectorAll('[data-swl-dock]').forEach(function (dock) {
      if (dock.dataset.swlReady) return;
      dock.dataset.swlReady = '1';
      if (!('IntersectionObserver' in window)) { dock.classList.add('on'); return; }
      var heroCtas = document.querySelector('.swl .hero .ctas'), close = dock.closest('.swl').querySelector('section');
      var heroIn = !!heroCtas, closeIn = false;
      var upd = function () { dock.classList.toggle('on', !heroIn && !closeIn); };
      if (heroCtas) new IntersectionObserver(function (es) { heroIn = es[0].isIntersecting; upd(); }).observe(heroCtas);
      if (close) new IntersectionObserver(function (es) { closeIn = es[0].isIntersecting; upd(); }).observe(close);
      upd();
    });
  }

  function init(root) {
    root = root || document;
    initPicker(root);
    initPour();
    initForm(root);
    initDock(root);
  }
  SWL.init = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
